module.exports = __webpack_public_path__ + "img/loginpagelogo1.7344a7a6.png";